import React, { useMemo } from 'react';
import styled from 'styled-components';
import KeyValueTable from './KeyValueTable';

/*
 * FestivalsSection — Section 8 of Pambu Sheet.
 *
 * Up to 4 upcoming festivals + "View full month" drill-down link.
 * Falls back to next-30-day window if fewer than 4 in next 4 days.
 */

const DrillDownButton = styled.button`
  background: none;
  border: none;
  color: ${p => p.theme.colors.bands.exceptional};
  font-size: 13px;
  cursor: pointer;
  padding: ${p => p.theme.spacing[2]}px ${p => p.theme.spacing[3]}px;
  text-decoration: underline;
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
  display: block;
  min-height: 44px;
  text-align: left;

  &:hover { color: ${p => p.theme.colors.text.primary}; }
  &:focus {
    outline: 2px solid ${p => p.theme.colors.bands.exceptional};
    outline-offset: 2px;
  }
`;

const EmptyText = styled.div`
  padding: ${p => p.theme.spacing[3]}px;
  color: ${p => p.theme.colors.text.muted};
  font-size: 13px;
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
`;

function formatShortDate(dateStr, lang) {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr + 'T00:00:00');
    return d.toLocaleDateString(lang === 'ta' ? 'ta-IN' : 'en-IN', {
      day: 'numeric', month: 'short',
    });
  } catch (e) {
    return dateStr;
  }
}

const FestivalsSection = ({ festivals, lang = 'en', onShowFullMonth }) => {
  const upcoming = useMemo(() => {
    if (!festivals) return [];
    const list = festivals.upcoming || festivals.festivals || [];
    return list.slice(0, 4);
  }, [festivals]);

  if (!festivals) return null;

  const rows = upcoming.map((f, i) => ({
    key: `festival_${i}`,
    labelTa: lang === 'ta' ? (f.name_ta || f.name) : f.name,
    labelEn: lang === 'ta' ? f.name : (f.name_ta || ''),
    value: formatShortDate(f.date, lang),
    endTime: null,
  }));

  return (
    <>
      {rows.length > 0 ? (
        <KeyValueTable rows={rows} lang={lang} />
      ) : (
        <EmptyText>
          {lang === 'ta' ? 'வருகிற பண்டிகைகள் இல்லை' : 'No upcoming festivals'}
        </EmptyText>
      )}
      <DrillDownButton type="button" onClick={onShowFullMonth}>
        {lang === 'ta' ? 'முழு மாதமும் காட்டு →' : 'View full month →'}
      </DrillDownButton>
    </>
  );
};

export default FestivalsSection;
